module.exports = __webpack_public_path__ + "79fca3c5ce4d2a9a79c74f4bbdda7ecd.jpg";